export const initialState = {
    age: 0
}

export const ageReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'INCREMENT':
            return {
                ...state,
                age: state.age + 1
            }
        case 'DECREMENT':
            if(state.age <= 0) {
               return {
                    ...state,
                    age: state.age = 0
               }
            } else {
                return {
                    ...state,
                    age: state.age - 1
                }
            }
        default:
            return state;
    }
}